import React, { useRef, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
// import styled, { keyframes } from 'styled-components'
// import { slideInDown } from 'react-animations'
// import { fontSizeResponsive } from '../../theme/mixins'
import { checkUserSubscriptionStatus } from '../../../../../Api/backendApi'

// import menuTexts from '../../../../constants/staticTexts'
import { SettingsMenu, MenuDescriptionText } from '../SettingsMenu.jsx'
import styled from 'styled-components'
import moment from 'moment'

const EndSubscriptiontime = styled.span`
  font-weight: bolder;
  color: rgba(158, 13, 254, 1);
  margin-left: 5px;
`

const SubscriptionButton = styled.button`
  width: 250px;
  -webkit-align-self: flex-end;
  -ms-flex-item-align: end;
  align-self: flex-end;
  margin: 20px 20px 0px 0px;
  padding: 10px 20px;
  -webkit-transition: 0.4s ease-in-out all;
  transition: 0.4s ease-in-out all;
  border: 1px solid rgba(0, 0, 0, 0);
  font-family: 'Open Sans';
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.48;
  -webkit-letter-spacing: normal;
  -moz-letter-spacing: normal;
  -ms-letter-spacing: normal;
  letter-spacing: normal;
  text-align: center;
  color: white;
  background-color: #fe0d9f;
  box-shadow: 0 1.3px 1.2px -8px rgba(0, 0, 0, 0.02),
    0 3.1px 3px -8px rgba(0, 0, 0, 0.028),
    0 5.8px 5.6px -8px rgba(0, 0, 0, 0.035),
    0 10.3px 10.1px -8px rgba(0, 0, 0, 0.042),
    0 19.2px 18.8px -8px rgba(0, 0, 0, 0.05),
    0 46px 45px -8px rgba(0, 0, 0, 0.07);
`

const DropdownSubscription = ({ activeSubscriptionEndTime }) => {
  let history = useHistory()

  const [subStatus, setSubStatus] = useState(null)

  useEffect(() => {
    // Using an IIFE
    ;(async function getSub() {
      const subInfo = await checkUserSubscriptionStatus()
      await setSubStatus(subInfo)
    })()
  }, [])

  const goToSubPurchase = () => {
    history.push({
      pathname: '/wybierz-plan/sub',
      prolongSub: true,
    })
  }

  return (
    <>
      <MenuDescriptionText header headerColor>
        Aktywna subskrypcja
      </MenuDescriptionText>
      <MenuDescriptionText>
        Twoja subskrypcja MIAZGA by FMW jest aktywna do dnia:
        <EndSubscriptiontime>
          {subStatus &&
            moment(subStatus.subscription.expiration_date).format('DD-MM-YYYY')}
        </EndSubscriptiontime>
      </MenuDescriptionText>
      <MenuDescriptionText header headerColorAlt mt={'5%'}>
        Chcesz wydłużyć subskrypcję?
      </MenuDescriptionText>
      <SubscriptionButton onClick={goToSubPurchase}>
        Kup subskrypcję
      </SubscriptionButton>
    </>
  )
}

export default DropdownSubscription
